import { Wallet } from 'lucide-react';
import type { AdminCompanyBilling } from 'app/javascript/types/admin';
import HealthPanel from 'app/javascript/components/admin/company_health/HealthPanel';
import HealthRow from 'app/javascript/components/admin/company_health/HealthRow';

export default function BillingPanel({ billing }: { billing: AdminCompanyBilling }) {
  return (
    <HealthPanel icon={<Wallet className="size-4" />} title="Mensalidades">
      <HealthRow label="Planos cadastrados" value={billing.plans.toLocaleString('pt-BR')} />
      <HealthRow label="Assinaturas ativas" value={billing.active_subscriptions.toLocaleString('pt-BR')} />
      <HealthRow label="Cobranças em aberto" value={billing.open_charges.toLocaleString('pt-BR')} />
      <HealthRow label="Cobranças avulsas em atraso" value={billing.overdue_charges.toLocaleString('pt-BR')} />
    </HealthPanel>
  );
}
